<template>
  <div class="w100m">
    <div class="w100 flexVC" v-if="$store.state.isPc">
    <div class="header">
      <el-image
        class="header-img"
        :src="aboutImg"
        :fit="cover"></el-image>
      <div class="header-content flexVC">
        <img :src="logoImg" class="logo">
        <!--        <div class="marT50">趁早合作众多品牌实现互利共赢</div>-->
        <!--        <div class="marT20">{{content}}</div>-->
      </div>
    </div>
    <div class="fontS32 fontW6 C000A85">加入我们</div>
    <div class="content flexHC">
      <div class="content-item flexHC2" v-for="item in navJob"
           :class="currentType == item.type ? 'B000' : 'BFFF' "@click="switchJob(item.type)">{{item.title}}
      </div>
    </div>
    <div class="content-join" v-for="(item,index) in joinUsData">
      <div class="item-box flexHBC w100" @click="expandClick(index)">
        <div>{{item.title}}</div>
        <img src="../../assets/images/icon_about_arrow.png" class="arrow-img" :class="item.isShow ? 'arrow-img-roate0' :'arrow-img-roate90'">
      </div>
      <div class="item-child" v-show="item.isShow">
        <div class="item-title marT40 marB15">岗位职责</div>
        <div class="item-content" v-for="obligation in item.obligation">{{obligation}}</div>
        <div class="item-line"></div>
      </div>
      <div class="item-child" v-show="item.isShow">
        <div class="item-title marT40 marB15">任职要求</div>
        <div class="item-content" v-for="child in item.requirement">{{child}}</div>
        <div class="item-line"></div>
      </div>
      <div class="item-child" v-show="item.isShow">
        <div class="item-title marT40 marB15">工作地点</div>
        <div class="item-content" >{{item.address}}</div>
        <div class="item-line"></div>
      </div>
      <div class="item-child" v-show="item.isShow">
        <div class="item-title marT40 marB15">简历投递邮箱</div>
        <div class="item-content" >{{item.email}}</div>
        <div class="item-line"></div>
      </div>
    </div>
    <div class="C000A25 fontW3 fontS32 marT50" style="padding-bottom: 80px;"></div>
  </div>
    <div class="w100 BFFF flexVC" v-if="!$store.state.isPc">
      <div class="header-m">
        <el-image
          class="header-img"
          :src="aboutImg"
          :fit="cover"></el-image>
        <div class="header-content flexVC">
          <img :src="logoImg" class="logo-m">
          <!--        <div class="marT50">趁早合作众多品牌实现互利共赢</div>-->
          <!--        <div class="marT20">{{content}}</div>-->
        </div>
      </div>
      <div class="fontS32m fontW6 C000A85">加入我们</div>
      <div class="content-m flexWrap">
        <div class="content-item-m flexHC2" v-for="item in navJobM"
             :class="currentType == item.type ? 'B000' : 'BFFF-m' "@click="switchJob(item.type)">{{item.title}}
        </div>
        <div class="content-item-m-empty flexHC2" v-for="count in 6">
        </div>
      </div>
      <div class="content-join-m" v-for="(item,index) in joinUsData" >
        <div class="item-box-m flexHBC w100" @click="expandClick(index)">
          <div>{{item.title}}</div>
          <img src="../../assets/images/icon_about_arrow.png" class="arrow-img-m" :class="item.isShow ? 'arrow-img-roate0' :'arrow-img-roate90'">
        </div>
        <div class="item-child" v-show="item.isShow">
          <div class="item-title-m marT40m marB15m">岗位职责</div>
          <div class="item-content-m" v-for="obligation in item.obligation">{{obligation}}</div>
          <div class="item-line-m"></div>
        </div>
        <div class="item-child" v-show="item.isShow">
          <div class="item-title-m marT40m marB15m">任职要求</div>
          <div class="item-content-m" v-for="child in item.requirement">{{child}}</div>
          <div class="item-line-m"></div>
        </div>
        <div class="item-child" v-show="item.isShow">
          <div class="item-title-m marT40m marB15m">工作地点</div>
          <div class="item-content-m" >{{item.address}}</div>
          <div class="item-line-m"></div>
        </div>
        <div class="item-child" v-show="item.isShow">
          <div class="item-title-m marT40m marB15m">简历投递邮箱</div>
          <div class="item-content-m" >{{item.email}}</div>
          <div class="item-line-m"></div>
        </div>
      </div>
      <div class="C000A25 fontW3 fontS32 marT50" style="padding-bottom: 80px;"></div>
    </div>
    <shape-footer></shape-footer>
  </div>
</template>

<script>
  import logoImg from '@/assets/images/icon_about_logo.png'
  import shapeFooter from '@/components/ShapeFooter'
  import {joinUsData} from '@/utils/staticData'

  export default {
    name: "AboutJoinUs",
    data() {
      return {
        cover: 'cover',
        aboutImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_join_us.png',
        logoImg: logoImg,
        content: '欢迎各大品牌合作交流，共同携手为品牌助力，见证美好的发生',
        joinUsData: [],
        joinUsDataTemp: [],
        currentType: 0,
        navJob: [{
          title: '全部职位',
          type: 0,
        }, {
          title: '技术',
          type: 1,
        }, {
          title: '产品',
          type: 2,
        }, {
          title: '设计',
          type: 3,
        }, {
          title: '运营',
          type: 4,
        }, {
          title: '视频',
          type: 5,
        },],
        navJobM: [{
          title: '全部',
          type: 0,
        }, {
          title: '技术',
          type: 1,
        }, {
          title: '产品',
          type: 2,
        }, {
          title: '设计',
          type: 3,
        }, {
          title: '运营',
          type: 4,
        }, {
          title: '视频',
          type: 5,
        },]
      }
    },

    components: {
      shapeFooter,
    },

    mounted() {
      window.scrollTo(0,0);
      if (!this.$store.state.isPc) {
        this.$store.commit('isAlphaEdit', true)
      }
      this.$store.commit('edit',3)
      this.joinUsData = joinUsData
    },

    methods: {
      expandClick(index){
        this.joinUsData[index].isShow  = !this.joinUsData[index].isShow
      },
      switchJob(type){
        this.currentType = type
        if (type == 0) {
          this.joinUsData = joinUsData
        } else {
          let list = []
          joinUsData.forEach(item => {
            if (item.type == type) {
              list.push(item)
            }
          })
          this.joinUsData = list
        }
      }
    },

  }
</script>

<style scoped>

  .header {
    width: 100%;
    height: 600px;
    position: relative;
    margin-bottom: 80px;
  }

  .header-img {
    width: 100%;
    height: 100%;
    background: #f00;
  }

  .header-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
  }

  .logo {
    width: 128px;
    height: 128px;
  }

  .marT80 {
    margin-top: 80px;
  }

  .fontS32 {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS24 {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS16 {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontW4 {
    font-weight: 400;
  }

  .C000A85 {
    color: rgba(0, 0, 0, 0.85);
  }

  .C000A25 {
    color: rgba(0, 0, 0, 0.15);
  }

  .C000A45 {
    color: rgba(0, 0, 0, 0.45);
  }

  .fontW6 {
    font-weight: 600;
  }

  .fontW3 {
    font-weight: 300;
  }

  .left-item {
    width: 496px;
  }

  .right-item {
    width: 496px;
  }

  .content {
    width: 920px;
    height: 60px;
    margin-top: 65px;
  }

  .content-join {
    width: 920px;
    margin-top: 50px;
  }

  .content-item {
    width: auto;
    padding: 0 51px;
    height: 60px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-top: 1px solid rgba(0, 0, 0, .06);
    border-bottom: 1px solid rgba(0, 0, 0, .06);
    cursor: pointer;
  }

  .BFFF {
    background: #ffffff;
    color: rgba(0, 0, 0, 0.85);
  }

  .B000 {
    background: #000000;
    color: #ffffff;
  }

  .logo-box {
    width: 70%;
    min-width: 1000px;

  }

  .logo-img {
    width: 119px;
    height: 70px;
  }

  .item-box {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
  }

  .arrow-img {
    width: 30px;
    height: 30px;
  }

  .arrow-img-roate90 {
    transform: rotate(-90deg);
  }
  .arrow-img-roate0 {
    transform: rotate(0deg);
  }

  .item-title{
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-left: 10px;
  }

  .item-content{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 30px;
  }

  .item-line{
    width: 100%;
    height: 1px;
    background: rgba(0,0,0,.06);
    margin-top: 40px;
  }

  .flexVR {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }


  /* ************************mobile*************************** */
  .header-m {
    width: 100%;
    height: 4rem;
    position: relative;
    margin-bottom: 0.8rem;
  }

  .business-item{
    width: 6.54rem;
    height: 1rem;

    border-top: 1px solid rgba(0,0,0,0.06);
  }

  .content-m {
    /*width: 6.54rem;*/
    height: 60px;
    margin-top: 0.44rem;
  }

  .content-item-m-empty{
    width: 1.04rem;
    height: 1px;
    margin-right: 0.32rem;
  }

  .content-item-m{
    width: 1.04rem;
    height: 0.48rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    cursor: pointer;
    /*margin-left: 0.16rem;*/
    margin-right: 0.32rem;
    margin-top: 0.2rem;
  }

  .content-join-m {
    width: 6.54rem;
    margin-top: 0.80rem;
  }

  .BFFF-m {
    background: rgba(0, 0, 0, 0.04);
    color: rgba(0, 0, 0, 0.85);
  }

  .logo-m {
    width: 1.24rem;
    height: 1.24rem;
  }


  .item-box-m {
    font-size: 0.32rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
  }

  .arrow-img-m {
    width: 0.30rem;
    height: 0.30rem;
  }

  .item-title-m{
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-left: 10px;
  }

  .item-content-m{
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 30px;
  }

  .item-line-m{
    width: 100%;
    height: 1px;
    background: rgba(0,0,0,.06);
    margin-top: 0.40rem;
  }

  .fontS32m {
    font-size: 0.32rem;
  }

  .fontS24m {
    font-size: 0.24rem;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .fontS28m{
    font-size: 0.28rem;
    font-family: PingFangSC-Semibold, PingFang SC;
  }

  .marT10m {
    margin-top: 0.1rem;
  }

  .marT40m{
    margin-top: 0.4rem;
  }

  .marB15m{
    margin-bottom: 0.15rem;
  }

  /*  ********************** f0f2f5 *******/

</style>



// WEBPACK FOOTER //
// src/page/about/AboutJoinUs.vue